
        import 'PriceBreakdown.6fae66d.css-module'
        export default {"priceBreakdown":"priceBreakdown_PriceBreakdown_6fae66d"}
    